'use client'

import dynamic from 'next/dynamic'

const ThemeSelector = dynamic(
  () => import('../../phishtrainer/play/_player/components/ThemeSelector').then((m) => m.ThemeSelector),
  { ssr: false },
)

export function PlayerThemeSelector() {
  return <ThemeSelector />
}
